/*
 * Regels achter de tussentijdse wijziging, los van NewEmployee.vue.
 *
 * Zie de toelichting in logic/verlenging.js waarom deze regels hier staan.
 */

// Zo geeft NMBRS "geen datum" terug in een verplicht datumveld.
const LEGE_DATUM_NMBRS = '0001-01-01';

/**
 * De dag uit een datum van NMBRS, als YYYY-MM-DD.
 *
 * Bewust op de tekst en niet via moment of Date: "2026-05-31T00:00:00+02:00"
 * is de 31e, en een omrekening naar de tijdzone van de browser kan daar de 30e
 * van maken.
 */
function dagUitNmbrs(waarde){
  if(!waarde) return null;
  const gevonden = /^(\d{4}-\d{2}-\d{2})/.exec(String(waarde));
  if(!gevonden || gevonden[1] === LEGE_DATUM_NMBRS) return null;
  return gevonden[1];
}

/**
 * De einddatum en de proeftijd van het lopende contract bij een tussentijdse
 * wijziging: zoals ze in NMBRS staan.
 *
 * Een tussentijdse wijziging gaat over salaris, rooster, functie of
 * vergoedingen. NewEmployee.vue zette daarbij de einddatum van een contract
 * voor bepaalde tijd op vandaag plus een jaar min een dag, over de echte
 * einddatum uit NMBRS heen, en wiste de proeftijd. De backend schrijft beide
 * velden met Contract_Update terug, dus een loonsverhoging gaf de contractregel
 * in NMBRS stil een andere einddatum. Zie H9 in de audit van 01-10-2026.
 *
 * Wat hier nog wel gebeurt is opschonen van wat getContract teruggeeft:
 * - bij onbepaalde tijd stuurt de backend de datum van vandaag als einddatum
 *   mee (Carbon::parse(null)); die hoort leeg te zijn;
 * - de lege datum van NMBRS, 0001-01-01, telt de backend als een proeftijd;
 * - de proeftijd komt met een tijd erachter, de rest van het scherm rekent met
 *   YYYY-MM-DD.
 *
 * @param {object|null} jobFunction job_function zoals getContract hem teruggeeft
 * @returns {{fixed_term_expiration_date: string|null, probation: number,
 *            probation_expiration_date: string|null,
 *            probation_expiration_month: number|null}}
 */
export function contractperiodeBijWijziging(jobFunction){
  const functie = jobFunction || {};
  const proeftijdTot = dagUitNmbrs(functie.probation_expiration_date);
  return {
    fixed_term_expiration_date: functie.fixed_term ? dagUitNmbrs(functie.fixed_term_expiration_date) : null,
    probation: proeftijdTot ? 1 : 0,
    probation_expiration_date: proeftijdTot,
    probation_expiration_month: proeftijdTot ? functie.probation_expiration_month : null
  };
}
